export const ActionTypes = {
  SET_REGIONS: 'SET_REGIONS'
};
